import React, { useEffect, useState, useMemo } from 'react';
import FollowupAdminPresenter from "../../../presenters/screens/followup-admin.presenter";
import { IFollowupAdmin } from "@interfaces/screens/followup-admin.interface";
import AdminBySubproject from './admin-bySubproyect';
import AdminMassiveProcess from './admin-massive-process';
import AdminMigration from './admin-migration';
import { SingleCollapse } from "@/components/";

const FollowUpAdmin: React.FC = () => {
    const [dataColumns, setDataColumns] = useState(null);
    const view: IFollowupAdmin = {
        state: {
            dataColumns,
            setDataColumns
        },
    };
      
    const presenter = new FollowupAdminPresenter(view);
    
    const hasPermission = useMemo(() => 
        presenter.getAdminPermissions(),
		[presenter.currentUser, presenter.params]
	)

    const UserPermission = useMemo(() => 
        presenter.getUserPermissions(),
		[presenter.currentUser]
	)

    useEffect(() => {
        presenter.initialize();
    }, []);

    if(!hasPermission) return <h2 style={{color:"red", padding:"1rem"}}>{presenter.followupLabels.get('adminPermissionRequired')}</h2>
    else return (
        <>
            {dataColumns &&  
                <>
                    <SingleCollapse title={presenter.followupLabels.get('adminByProject')} isOpen={false}>
                        <AdminBySubproject dataColumns={dataColumns} ></AdminBySubproject>
                    </SingleCollapse>
                    <SingleCollapse title={presenter.followupLabels.get('adminMasiveProcess')} isOpen={false}>
                        <AdminMassiveProcess dataColumns={dataColumns} ></AdminMassiveProcess>
                    </SingleCollapse>
                    {UserPermission &&
                        <SingleCollapse title={"Migración"} isOpen={false}>
                            <AdminMigration></AdminMigration>
                        </SingleCollapse>
                    }
                </>
            }
        </>
    )
}

export default FollowUpAdmin;